import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/highrays-yt/highrays-yt/src/app/(public)/portfolio/client.tsx");
